module.exports = __webpack_public_path__ + "media/images/people/girl-4-437af9b7db84fd6f5726829ce12c3a3a.webp";